// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h2 {
    font-size: 1.5rem;
    font-weight: bold;
}

p {
    font-size: 1rem;
    line-height: 1.5em;
}

.crash-message_crash-wrapper_enCKA {
    background-color: var(--menu-bar-background);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.crash-message_body_nF3lY {
    width: 50%;
    color: white;
    text-align: center;
}

/* scratch-www was overriding the colors */

.crash-message_body_nF3lY p, .crash-message_body_nF3lY h2 {
    color: inherit;
}

.crash-message_reloadButton_lpNpQ {
    border: 1px solid var(--motion-primary);
    border-radius: 0.25rem;
    padding: 0.5rem 2rem;
    background: white;
    color: var(--motion-primary);
    font-weight: bold;
    font-size: 0.875rem;
    cursor: pointer;
}

.crash-message_header_gnVBl {
    font-size: 1.5em;
    font-weight: bold;
}

.crash-message_error-message_vylyd {
    white-space: pre-wrap;
    font-family: monospace;
}
`, "",{"version":3,"sources":["webpack://./src/components/crash-message/crash-message.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,2DAA2D;AAC/D;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA,0CAA0C;;AAE1C;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\nbody {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\nh2 {\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\np {\n    font-size: 1rem;\n    line-height: 1.5em;\n}\n\n.crash-wrapper {\n    background-color: var(--menu-bar-background);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.body {\n    width: 50%;\n    color: white;\n    text-align: center;\n}\n\n/* scratch-www was overriding the colors */\n\n.body p, .body h2 {\n    color: inherit;\n}\n\n.reloadButton {\n    border: 1px solid var(--motion-primary);\n    border-radius: 0.25rem;\n    padding: 0.5rem 2rem;\n    background: white;\n    color: var(--motion-primary);\n    font-weight: bold;\n    font-size: 0.875rem;\n    cursor: pointer;\n}\n\n.header {\n    font-size: 1.5em;\n    font-weight: bold;\n}\n\n.error-message {\n    white-space: pre-wrap;\n    font-family: monospace;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `crash-message_crash-wrapper_enCKA`;
export { _1 as "crash-wrapper" };
export var crashWrapper = `crash-message_crash-wrapper_enCKA`;
export var body = `crash-message_body_nF3lY`;
export var reloadButton = `crash-message_reloadButton_lpNpQ`;
export var header = `crash-message_header_gnVBl`;
var _2 = `crash-message_error-message_vylyd`;
export { _2 as "error-message" };
export var errorMessage = `crash-message_error-message_vylyd`;
export default ___CSS_LOADER_EXPORT___;
